import { CrudServiceBase } from '@utils';
import { Organization } from './organization.class';

type Entity = Organization;

export class OrganizationService extends CrudServiceBase<Entity> {
	constructor() {
		super(Organization, 'organization');
	}
}

export const organizationService = new OrganizationService();
